export enum SidebarId {
  /* HOME */
  HOME = 10,

  /* BONUS ENGINE */
  BONUS_ENGINE = 20,
  REPORTS = 21,
  SPORT_RO_CALCULATOR = 22,
  BONUS_WALLETS = 23,
  REPORTS_BALANCE = 24,

  /* GENERAL SETTINGS */
  USERS = 50,
}
